import { useMemo } from 'react'

import { useTexts } from '../../useTexts'

import { form } from '../../formState'

export function Threshold() {
  const texts = useTexts()

  const options = useMemo(
    () => [
      {
        value: '10',
        label: texts.proximityThresholdMinsValue(10),
      },
      {
        value: '20',
        label: texts.proximityThresholdMinsValue(20),
      },
      {
        value: '30',
        label: texts.proximityThresholdMinsValue(30),
      },
    ],
    [texts],
  )

  return (
    <form.SimpleSelect
      label={texts.proximityThresholdMinsLabel}
      name="proximityThresholdMins"
      testId="proximityThresholdMins"
      validateOn="focus blur"
      options={options}
    />
  )
}
